export const PRODUCT_DETAILS_REDUCER_NAME = 'productDetails'
